import React from 'react';

import Login from 'project/Login/Login';

const LoginPage = (): JSX.Element => <Login />;

LoginPage.hideMenu = true;

export default LoginPage;
